/* global PowerPoint console */

export async function clearGriddShapes(id) {
  let griddObjectId = undefined;
  try {
    await PowerPoint.run(async (context) => {
      const shapes = context.presentation.slides.getItem(id.slideId).shapes;
      // eslint-disable-next-line office-addins/no-navigational-load
      shapes.load("items/name");
      await context.sync();

      shapes.items.forEach(async (shape) => {
        if (shape.name.startsWith("Gridd_") || shape.name.startsWith("Graphic ")) {
          shape.delete();
        } else if (shape.name.startsWith("Content Placeholder") || shape.name.startsWith("Add-in")) {
          // record probable shape of own object
          griddObjectId = shape.id;
        }
      });
      await context.sync();
    });
  } catch (error) {
    console.error("Error during clean-up for new drawing, aborting baking.", error);
    throw error;
  }
  return griddObjectId;
}
